import { FieldErrors } from "react-hook-form"
import { ErrorMessage, Props } from "@hookform/error-message"
import { t } from "i18next"
import { FormError } from "@/components/ui/form"

const TranslatedFormError = ({ message }: { message: string }) => <FormError>{t(message)}</FormError>

export const TranslatedFieldError = <TFieldErrors extends FieldErrors, TAs extends React.ReactElement>({
  errors,
  name,
}: Props<TFieldErrors, TAs>) => <ErrorMessage errors={errors} name={name} render={TranslatedFormError} />
